<template>
  <div class="base-card">
    <div class="card-head" v-if="headerName" :class="{ 'no-border-bottom': hideHeadBottomLine }">
      <div class="head-left">
        <div class="head-line"></div>
        {{ headerName }}
      </div>
      <slot name="headerRight" v-if="$slots.headerRight"></slot>
    </div>
    <div class="card-content" v-if="$slots.default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    headerName: {
      type: String,
      default: ''
    },
    hideHeadBottomLine: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.base-card {
  padding: 0 12px 16px;
  position: relative;
  background: #ffffff;
  box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  .card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    border-bottom: 1px #eee solid;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    &.no-border-bottom {
      border: none;
    }
    .head-left {
      display: flex;
      align-items: center;
      .head-line {
        margin-right: 6px;
        width: 4px;
        height: 12px;
        background: #fe6a23;
        border-radius: 2px;
      }
    }
  }
  .card-content {
    padding-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseCard.vue